/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import AnchorLink, { AnchorLinkProps } from '../AnchorLink'

export type PhoneLinkProps = Omit<AnchorLinkProps, 'to'> & {
  phone: string
}

function PhoneLink (props: PhoneLinkProps) {
  const { phone, ...others } = props
  if (phone) {
    const n = String(phone).replace(/[^\d]+/g, '')
    return (
      <AnchorLink {...others} to={`tel:${n}`}>
        {phone}
      </AnchorLink>
    )
  }
  return null
}

export default PhoneLink
